<li>
  <a type="button" class="button-component" [routerLink]="[value.link]" (click)="handleClick($event)">
    <ng-container *ngComponentOutlet="value.svg"></ng-container>
    <span>{{ value.label }}</span>
  </a>
</li>
